// ================================================================================
// constants.js — Shared data, lookups, and cohort intelligence
// ================================================================================

import AGE_DATA_18_24 from "../../../data/demographics/cohort_summary_18_24.json";
import AGE_DATA_25_34 from "../../../data/demographics/cohort_summary_25_34.json";
import AGE_DATA_35_44 from "../../../data/demographics/cohort_summary_35_44.json";
import AGE_DATA_45_54 from "../../../data/demographics/cohort_summary_45_54.json";
import AGE_DATA_55_64 from "../../../data/demographics/cohort_summary_55_64.json";
import AGE_DATA_64_75 from "../../../data/demographics/cohort_summary_64_75.json";
import AGE_DATA_75_PLUS from "../../../data/demographics/cohort_summary_75_plus.json";

export { default as ARCHETYPE_DATA } from "../../../data/archetype_summary.json";

// Unified Cohort Data Lookup
export const COHORT_FILES = [
    AGE_DATA_18_24, AGE_DATA_25_34, AGE_DATA_35_44,
    AGE_DATA_45_54, AGE_DATA_55_64, AGE_DATA_64_75, AGE_DATA_75_PLUS
];

// Build a fast lookup map for profiles and cohort context
export const COHORT_INTELLIGENCE = (() => {
    const profileMap = {};
    const cohortContextMap = {};

    COHORT_FILES.forEach(fileData => {
        if (Array.isArray(fileData)) {
            const mainSegment = fileData.find(item => item.segment_name && item.profiles);

            if (mainSegment) {
                const ageRange = mainSegment.age_range;

                // Store Cohort Context
                cohortContextMap[ageRange] = {
                    cultural_designator: mainSegment.cultural_designator,
                    segment_context: mainSegment.segment_context,
                    dominant_tension: mainSegment.cohort_data?.dominant_tension
                };

                // Store Profile Data with Smart Aliasing
                if (mainSegment.profiles) {
                    Object.entries(mainSegment.profiles).forEach(([jsonKey, profile]) => {
                        const cleanKey = jsonKey.trim();
                        profileMap[cleanKey] = { ...profile, _age_range: ageRange };

                        if (cleanKey.includes('MILLENNIAL_')) {
                            const shortKey = cleanKey.replace('MILLENNIAL_', 'MILL_');
                            if (!profileMap[shortKey]) profileMap[shortKey] = { ...profile, _age_range: ageRange };
                        } else if (cleanKey.includes('MILL_')) {
                            const longKey = cleanKey.replace('MILL_', 'MILLENNIAL_');
                            if (!profileMap[longKey]) profileMap[longKey] = { ...profile, _age_range: ageRange };
                        }

                        if (profile.mapped_archetype && profile.mapped_archetype !== cleanKey) {
                            profileMap[profile.mapped_archetype] = { ...profile, _age_range: ageRange };
                        }
                    });
                }
            }
        }
    });

    return { profiles: profileMap, contexts: cohortContextMap };
})();

export const ARCHETYPE_AGE_DEFAULTS = {
    'young_professional_urban': { '18-24': 0.22, '25-39': 0.38, '40-59': 0.28, '60+': 0.12 },
    'established_suburban_family': { '18-24': 0.08, '25-39': 0.22, '40-59': 0.35, '60+': 0.35 },
    'retirement_community': { '18-24': 0.05, '25-39': 0.15, '40-59': 0.25, '60+': 0.55 },
    'mixed_demographic': { '18-24': 0.12, '25-39': 0.28, '40-59': 0.35, '60+': 0.25 },
    'working_class_traditional': { '18-24': 0.14, '25-39': 0.26, '40-59': 0.38, '60+': 0.22 }
};
